import { TableName } from '../../constants/table';
import { doesEntityExist } from '../../lib/services/api-service';

export const validateUser = async (
  tenantId: string,
  email: string
): Promise<{ isValid: boolean; message: string }> => {
  // Check if the email matches the regular expression
  const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
    email
  );

  if (!isValidEmail) {
    return { isValid: false, message: 'Invalid email format' };
  }

  try {
    // Check if the user already exists
    const exists = await doesEntityExist(TableName.Users, tenantId, email);
    if (exists) {
      // toast.warn('User already exists');
      return { isValid: false, message: 'User already exists' };
    }

    return { isValid: true, message: 'User is valid' };
  } catch (error) {
    return { isValid: false, message: 'Failed to validate user' };
  }
};
